import { UseMutationResult, useMutation } from '@tanstack/react-query';
import {
  CreditUnitsRequest,
  TransferPractitionerUnitsRequest,
  TransferEventUnitsRequest,
  TransferUnitsResponse,
} from 'api/httpEntities';
import {
  creditUnitsToPractitionerWallet,
  removeUnitsFromPractitionerWallet,
  transferEventUnits,
  transferPractitionerUnits,
} from 'api';

export const useCreditUnitsToPractitionerWallet = (): UseMutationResult<
  void,
  Error,
  CreditUnitsRequest,
  unknown
> => useMutation({ mutationFn: creditUnitsToPractitionerWallet });

export const useRemoveUnitsFromPractitionerWallet = (): UseMutationResult<
  void,
  Error,
  CreditUnitsRequest,
  unknown
> => useMutation({ mutationFn: removeUnitsFromPractitionerWallet });

export const useTransferPractitionerUnits = (): UseMutationResult<
  TransferUnitsResponse,
  Error,
  TransferPractitionerUnitsRequest,
  unknown
> => useMutation({ mutationFn: transferPractitionerUnits });

export const useTransferEventUnits = (): UseMutationResult<
  TransferUnitsResponse,
  Error,
  TransferEventUnitsRequest,
  unknown
> => useMutation({ mutationFn: transferEventUnits });
